export default "__VITE_ASSET__CUoKZKo8__"